import type { ApiError } from '@/types/api';

/** RTK Query axiosBaseQuery attaches {@link ApiError} with numeric HTTP status. */
export function isApiForbiddenError(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;
  const e = error as Partial<ApiError>;
  return e.status === 403;
}
